import { selectboxBlueprint } from "@made-people/blueprint-form/blueprint";

selectboxBlueprint.override({
  slots: {
    base: "relative w-full flex flex-col gap-2",
    fieldLabel: "text-heading-xs",
    listBoxButton:
      "h-11 relative items-center w-full text-left focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-black cursor-pointer bg-white",
    listBoxArrow:
      "w-3 h-3 flex items-center justify-center absolute top-1/2 right-4 -translate-y-1/2",
    listBoxOptions:
      "w-[var(--button-width)] absolute z-20 mt-1 !max-h-60 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in",
    listBoxOption:
      "flex justify-between items-center group relative select-none py-2 data-[focus]:bg-neutral-100 text-black data-[focus]:outline-none",
    listBoxLabel:
      "block truncate text-label-md group-data-[selected]:font-medium",
    listBoxIcon: "flex items-center justify-center h-5 w-5 mr-2 relative",
    listBoxCheck:
      "relative w-2.5 h-2.5 flex items-center justify-center text-black group-[&:not([data-selected])]:hidden group-data-[focus]:text-white",
  },
  variants: {
    style: {
      border: {
        listBoxButton:
          "outline outline-1 -outline-offset-1 outline-neutral-200 bg-white",
      },
      solid: {
        listBoxButton: "",
      },
    },
    rounded: {
      full: {
        listBoxButton: "rounded-full pl-5 pr-10",
        listBoxOption: "px-3",
      },
      md: {
        listBoxButton: "rounded-md px-3",
        listBoxOption: "px-3",
      },
    },
  },
});
